import { Button, Dialog, DialogContent, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import { TOrderHistoryRow, TOrderDetail, TOrderLineItem } from '@/core/store/orderHistory.store'
import { formattedDate } from '@/core/utils/utils'

const formatCurrency = (value: number | string | undefined) => {
    if (value === undefined || value === null || value === '') return '-'
    const numeric = Number(value)
    if (Number.isNaN(numeric)) return String(value)
    return numeric.toLocaleString('en-US')
}

const extractLineItems = (detail?: TOrderDetail): TOrderLineItem[] => {
    const items = detail?.lines?.items ?? []
    const totalPV = detail?.terms?.pv ?? '-'

    return items.map((item, index) => {
        return {
            number: item?.number ?? index + 1,
            product: item?.catalogSlide?.content?.description ?? '-',
            quantity: item?.quantity ?? '-',
            pv: totalPV
        }
    })
}

type ModalOrderDetailsProps = {
    open: boolean
    onClose: () => void
    order: TOrderHistoryRow | null
    customerName: string
    customerId: string
}

const ModalOrderDetails = ({ open, onClose, order, customerId, customerName }: ModalOrderDetailsProps) => {
    const detail = order?.order_detail
    const formattedOrderDate = detail?.dateCreated ? formattedDate(detail.dateCreated) : '-'
    const pvMonth = detail?.terms?.period ?? '-'
    const totalAmount = formatCurrency(detail?.terms?.total) ?? '-'
    const totalPv = detail?.terms?.pv ?? '-'
    const shippingInfo = detail?.shipToName?.fullName ?? '-'
    const lineItems = extractLineItems(detail)

    return (
        <Dialog open={open} onClose={onClose} aria-labelledby="modal-order-details-title">
            <DialogContent
                sx={{
                    width: '100%',
                    maxWidth: 760,
                }}>
                <Stack spacing={2} p={3}>
                    <Typography id="modal-order-details-title" fontWeight={700} variant="subtitle1" color='black' fontSize={'16px'}>
                        Đặt hàng theo id: {customerId || '-'}, {customerName || '-'}
                    </Typography>

                    <TableContainer>
                        <Table size="medium" sx={{ border: '1px solid #e5e7eb' }}>
                            <TableBody>
                                <TableRow>
                                    <TableCell sx={{ fontWeight: 600, width: '33%', textAlign: 'center', borderRight: '1px solid #e5e7eb' }}>Đơn hàng #{order?.order_id ?? '-'}</TableCell>
                                    <TableCell sx={{ fontWeight: 600, width: '33%', textAlign: 'center', borderRight: '1px solid #e5e7eb' }}>Tháng PV {pvMonth}</TableCell>
                                    <TableCell sx={{ fontWeight: 600, width: '33%', textAlign: 'center', borderRight: '1px solid #e5e7eb' }}>Tổng tiền {totalAmount}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell sx={{ textAlign: 'center', borderRight: '1px solid #e5e7eb' }}>{shippingInfo}</TableCell>
                                    <TableCell sx={{ textAlign: 'center', borderRight: '1px solid #e5e7eb' }}>{formattedOrderDate}</TableCell>
                                    <TableCell sx={{ textAlign: 'center', borderRight: '1px solid #e5e7eb' }}>Tổng PV {totalPv}</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>

                    <TableContainer>
                        <Table size="medium" sx={{ border: '1px solid #e5e7eb' }}>
                            <TableHead sx={{ backgroundColor: '#0f172a' }}>
                                <TableRow>
                                    <TableCell sx={{ color: '#fff', fontWeight: 700, textAlign: 'center', borderRight: '1px solid #e5e7eb' }}>Số</TableCell>
                                    <TableCell sx={{ color: '#fff', fontWeight: 700, textAlign: 'center', borderRight: '1px solid #e5e7eb' }}>Sản phẩm</TableCell>
                                    <TableCell sx={{ color: '#fff', fontWeight: 700, textAlign: 'center', borderRight: '1px solid #e5e7eb' }}>Số lượng</TableCell>
                                    <TableCell sx={{ color: '#fff', fontWeight: 700, textAlign: 'center', borderRight: '1px solid #e5e7eb' }}>PV</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody sx={{ border: '1px solid #e5e7eb' }}>
                                {lineItems.length === 0 ? (
                                    <TableRow>
                                        <TableCell colSpan={4} sx={{ py: 3, textAlign: 'center', color: 'text.secondary', borderRight: '1px solid #e5e7eb' }}>
                                            Không có dữ liệu
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    lineItems.map(item => (
                                        <TableRow key={`${item.number}`}>
                                            <TableCell sx={{ borderRight: '1px solid #e5e7eb', textAlign: 'center' }}>{item.number ?? '-'}</TableCell>
                                            <TableCell sx={{ borderRight: '1px solid #e5e7eb' }}>
                                                {item.product ?? '-'}
                                            </TableCell>
                                            <TableCell sx={{ borderRight: '1px solid #e5e7eb', textAlign: 'center' }}>{item.quantity ?? '-'}</TableCell>
                                            <TableCell sx={{ borderRight: '1px solid #e5e7eb', textAlign: 'center' }}>{item.pv ?? '-'}</TableCell>
                                        </TableRow>
                                    ))
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>

                    <Stack direction="row" justifyContent="center" pt={1}>
                        <Button variant="contained" color="inherit" sx={{ backgroundColor: '#1f2937', color: '#fff', px: 5, textTransform: 'capitalize' }} onClick={onClose}>
                            Đơng
                        </Button>
                    </Stack>
                </Stack>
            </DialogContent>
        </Dialog>
    )
}

export default ModalOrderDetails